<script setup lang="ts">
import { computed, inject } from "vue";
import { FormElementType, SelectListFormElement } from "~/api";
import {
  FormResponseState,
  formResponseInjectKey,
} from "../../composables/useFormResponse";
import { DefaultFormComponentProps } from "./FormComponentRenderer.vue";

const props = defineProps<DefaultFormComponentProps<SelectListFormElement>>();

const { useAnswer, substituteTemplatedText } = inject(
  formResponseInjectKey,
  // Cast the type since we know it is always provided. For more info see:
  // https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
) as FormResponseState;
const answer = useAnswer<FormElementType.SELECT_LIST>(props.modelValue);
const elementProperties = computed(() => props.modelValue.properties);
</script>

<template>
  <div class="SelectListComponent">
    <slot name="label" :element="modelValue" />

    <div style="flex-grow: 1"></div>

    <el-select
      :model-value="answer ?? undefined"
      :placeholder="
        substituteTemplatedText(modelValue.properties.placeholder) ?? ''
      "
      :disabled="isReadOnly"
      :clearable="modelValue.properties.isOptional ?? undefined"
      @update:model-value="answer = $event ?? null"
    >
      <el-option
        v-for="{ label, value } in elementProperties.selectListOptions"
        :key="value"
        :label="label"
        :value="value"
      >
        <span>{{ label }}</span>
        <span v-if="props.showOptionValues" class="component-question-code">
          {{ value }}</span
        >
      </el-option>
    </el-select>
  </div>
</template>

<style lang="less">
.el-select-dropdown {
  .component-question-code {
    border: 1px solid var(--el-color-danger);
    width: fit-content;
    height: fit-content;
    padding: 0px 6px;
    margin: 0px 0 0 12px;
    font-size: 0.8em;
    background-color: var(--el-color-info-light-9);
    color: var(--el-text-color-primary);
    border-radius: 0.5em;
  }
}
.SelectListComponent {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;

  .el-select__selection {
    text-align: right;
  }
  .el-select {
    .el-select__wrapper.is-disabled,
    .el-select__wrapper.is-disabled.is-hovering {
      box-shadow: 0 0 0 1px var(--el-disabled-border-color) inset;
      background-color: #f2f2f2;
      .el-select__placeholder {
        color: #444142;
      }
    }
  }
}

body.forPdf .SelectListComponent {
  .el-select {
    width: fit-content;
    .el-select__selection {
      text-align: right;
    }
    .el-select__wrapper {
      box-shadow: 0 0 0 1px var(--el-disabled-border-color) inset;
      background-color: transparent !important;
      .el-select__placeholder {
        color: black !important;
      }
    }
  }
  .el-select__wrapper {
    box-shadow: 0 0 0 1px var(--el-disabled-border-color) inset;
    background-color: transparent !important;
    .el-select__placeholder {
      color: black !important;
    }
  }
}
</style>
